import { render, staticRenderFns } from "./ColorKitUnboxed.vue?vue&type=template&id=12137eec&scoped=true&lang=pug&"
import script from "./ColorKitUnboxed.vue?vue&type=script&lang=js&"
export * from "./ColorKitUnboxed.vue?vue&type=script&lang=js&"
import style0 from "./ColorKitUnboxed.vue?vue&type=style&index=0&id=12137eec&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12137eec",
  null
  
)

export default component.exports